import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FormatedDate } from 'Utils/functions'

export const AuditSection = ({
  createdByName,
  lastEditByName,
  lastEditDate,
  showPriceApproval,
  isPriceApprovalPending,
  priceApprovedByName,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className="quotation-audit-section"
      data-testid="container-audit-section">
      <div className="quotation-audit-item">
        <p className="quotation-audit-label">
          {t('EDIT_QUOTATION_AUDIT_T.CREATED_BY_LABEL')}
        </p>
        <p className="quotation-audit-value" data-testid="text-created-by">
          {createdByName || t('EDIT_QUOTATION_AUDIT_T.UNKNOWN_USER')}
        </p>
      </div>
      {lastEditByName && (
        <div className="quotation-audit-item">
          <p className="quotation-audit-label">
            {t('EDIT_QUOTATION_AUDIT_T.LAST_EDIT_LABEL')}
          </p>
          <p className="quotation-audit-value" data-testid="text-last-edit">
            {lastEditByName}
            {lastEditDate ? ` – ${FormatedDate(lastEditDate)}` : ''}
          </p>
        </div>
      )}
      {showPriceApproval && (
        <div className="quotation-audit-item">
          <p className="quotation-audit-label">
            {t('EDIT_QUOTATION_AUDIT_T.PRICE_APPROVAL_LABEL')}
          </p>
          <p
            className={`quotation-audit-value${
              isPriceApprovalPending ? ' quotation-audit-value-pending' : ''
            }`}
            data-testid="text-price-approval">
            {isPriceApprovalPending
              ? t('EDIT_QUOTATION_AUDIT_T.PRICE_APPROVAL_PENDING')
              : priceApprovedByName || t('EDIT_QUOTATION_AUDIT_T.UNKNOWN_USER')}
          </p>
        </div>
      )}
    </div>
  )
}

AuditSection.propTypes = {
  createdByName: PropTypes.string,
  lastEditByName: PropTypes.string,
  lastEditDate: PropTypes.string,
  showPriceApproval: PropTypes.bool,
  isPriceApprovalPending: PropTypes.bool,
  priceApprovedByName: PropTypes.string,
}
